import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StatusLabelComponent } from '@zaoblako/web/shared/components/status-label/status-label.component';
import { HighlightMatchPipe } from '@zaoblako/web/shared/pipes/highlight-match.pipe';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import type { StandardDropdownItemInterface } from '@zaoblako/shared/common/interfaces/standard-dropdown-item.interface';

@Component({
  selector: 'crm-standard-dropdown-item',
  standalone: true,
  templateUrl: './standard-dropdown-item.component.html',
  styleUrl: './standard-dropdown-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HighlightMatchPipe, SafeHtmlPipe, StatusLabelComponent]
})
export class StandardDropdownItemComponent {
  @Input() public item: StandardDropdownItemInterface;
  @Input() public filterValue = '';
  /** One line for virtual scroll. Extra text, the description and the status stay on that line. */
  @Input() public singleLine = false;
}
